import React from 'react';

const customVideoAttributes = { 'webkit-playsinline': 'true' };

export interface VideoProps
  extends Pick<
    React.DOMAttributes<HTMLVideoElement>,
    'onPause' | 'onPlaying' | 'onEnded' | 'onError' | 'onPlay'
  > {
  className?: string;
  thumbUrl?: string;
  videoUrl: string;
  setRef?: React.RefObject<HTMLVideoElement>;
  controls?: boolean;
  autoPlay?: boolean;
}

const Video = (props: VideoProps) => (
  <video
    className={props.className}
    id='greet-vid'
    onPlay={props.onPlay}
    onPause={props.onPause}
    onPlaying={props.onPlaying}
    onEnded={props.onEnded}
    onError={props.onError}
    {...customVideoAttributes}
    preload='auto'
    width={'100%'}
    poster={props.thumbUrl}
    ref={props.setRef}
    playsInline
    src={props.videoUrl}
    controls={props.controls}
    {...props}
  >
    <span>Your browser does not support the video tag.</span>
  </video>
);

export default Video;
